import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center w-full pt-4 space-y-4 h-[calc(100vh - 28rem)" }
const _hoisted_2 = { class: "grid w-1/2 grid-cols-2 overflow-y-auto gap-x-2 gap-y-4 custumScroll" }
const _hoisted_3 = { class: "flex flex-col col-span-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Nom de l'agence "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Adresse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Contact "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Boite Postale "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_13 = { class: "flex flex-col col-span-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (facultatif)")
], -1)
const _hoisted_15 = { class: "flex flex-col w-1/2" }
const _hoisted_16 = { class: "flex flex-col pt-4 w-full space-y-4 justify-center items-center h-[calc(100vh - 28rem)]" }
const _hoisted_17 = { class: "flex flex-col items-start justify-start w-1/2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "w-full font-light text-md" }, "Ajouter une responsabilité", -1)
const _hoisted_19 = { class: "flex items-start w-full space-x-2 cursor-pointer" }
const _hoisted_20 = { class: "flex flex-row items-start w-full space-x-2" }
const _hoisted_21 = { class: "flex flex-col w-1/2" }
const _hoisted_22 = { class: "flex flex-col w-1/2" }
const _hoisted_23 = { class: "flex flex-col w-1/2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-light text-md" }, "Responsables de l'agence", -1)
const _hoisted_25 = { class: "text-gray-400" }
const _hoisted_26 = { class: "text-gray-400" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, /*#__PURE__*/_toDisplayString("Illimité"), -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-gray-300" }, " Vous êtes sur le point de créer un nouvel utilisateur lié à cette succursale. Ce dernier recevra un mail de de notification contenant les informations décrivant le protocole d'accès à cette succursale. ", -1)
const _hoisted_29 = { class: "grid w-full grid-cols-2 gap-4" }
const _hoisted_30 = { class: "flex flex-col col-span-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Nom d'utilisateur "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_32 = { class: "flex flex-col" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Adresse E-mail"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_34 = { class: "flex flex-col w-full" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Niveau d'accès"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_36 = { class: "flex flex-row items-end justify-end w-full" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-gray-300" }, " Voulez-vous vraiment retirer les droits d'accès à cet utilisateur ? ", -1)
const _hoisted_38 = { class: "flex flex-row items-end justify-end w-full" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-gray-300" }, " Voulez-vous vraiment retirer temporairement les droits d'accès à cet utilisateur ? ", -1)
const _hoisted_40 = { class: "flex flex-row items-end justify-end w-full" }
const _hoisted_41 = { class: "flex flex-col" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-gray-300" }, " Vous êtes sur le point d'assigner des droits d'accès à cet utilisateur. Veuillez fournir une adresse e-mail valide. Ce dernier recevra un mail de confirmation. ", -1)
const _hoisted_43 = { class: "flex flex-col col-span-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Adresse E-mail "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_45 = { class: "flex flex-row items-end justify-center w-full" }

import api from "@/api";
	import { ref, watch, onMounted, watchEffect, provide, inject, onBeforeMount } from "vue";
	import rules from "@/rules";
	import { validateAll } from "@/validator";
	import useNotyf from "@/composable/useNotyf";
	import { currentStation, getAllStationsUser, refreshUserInfos, rolesUser } from "@/state/api/userState";
	import { generateQueryParams } from "@/utils";
import { getAllRoles } from "@/services/global";

	/**
	 * Variables
	 */
	
export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateAgency',
  setup(__props) {

	const stationIDSelected: any = ref(inject("stationIDSelected"));
	const stationUUIDSelected: any = ref(inject("stationUUIDSelected"));
	const getAllStations: any = inject("getAllStations");
	const currentTab = ref<any>(null);
	const notify = useNotyf();
	const selectedRow = ref({});
	const staffSelected = ref(null);
	const roleSelected = ref(null);
	const stationID = ref<any>(null);
	// const stationInfos = ref<any>();
	const managerData = ref<any>([]);
	const isLoading = ref(false);
	const stationInfos = ref<any>({
		station_name: null,
		city: null,
		station_address: null,
		station_phone: null,
		station_email: null,
		zip_code: null,
		postal_box: null,
		description: null,
	});
	const assignRoleData = ref({
		station: stationIDSelected.value,
		email: null,
		personal_id: null,
		role: null,
	});

	// const roleData = ref<any>([
	// 	{ value: "Directeur d'agence", key: "3" },
	// 	{ value: "Gestionnaire de caisse", key: "5" },
	// ]);

	const roleData = ref<any>([]);

	const staffData = ref<any>([]);
	const tabProps = ref<any>([
		{ name: "global", label: "Informations Générales" },
		{ name: "administration", label: "Administration" },
	]);
	const newManagerData = ref<any>({});
	const validations = ref<any>({
		staffSelected: {
			staff: {
				value: assignRoleData,
				validator: (value: any) => value.personal_id != null,
				msg: {
					error: "Sélectionnez un membre du personnel",
				},
			},
			role: {
				value: assignRoleData,
				validator: (value: any) => value.role != null,
				msg: {
					error: "Sélectionnez un rôle",
				},
			},
		},
		assignRole: {
			email: {
				value: assignRoleData,
				validator: (value: any) => rules.global.email.test(value.email),
				msg: {
					error: "L'e-mail doit être valide",
				},
			}
		},
		station: {
			station_name: {
				value: stationInfos,
				validator: (value: any) => rules.station.name.test(value.station_name),
				msg: {
					error: "Le nom de l'agence doit contenir au moins 3 caractères",
				},
			},
			station_email: {
				value: stationInfos,
				validator: (value: any) => rules.global.email.test(value.station_email),
				msg: {
					error: "L'e-mail de l'agence doit être valide",
				},
			},
			station_address: {
				value: stationInfos,
				validator: (value: any) => rules.global.address.test(value.station_address),
				msg: {
					error: "L'adresse de l'agence doit contenir au moins 5 caractères",
				},
			},
			station_phone: {
				value: stationInfos,
				validator: (value: any) => rules.global.phone.test(value.station_phone),
				msg: {
					error: "Le téléphone de l'agence doit être valide",
				},
			},
			postal_box: {
				value: stationInfos,
				validator: (value: any) => rules.global.postalBox.test(value.postal_box),
				msg: {
					error: "La boîte postale de l'agence est invalide",
				},
			},
			description: {
				value: stationInfos,
				validator: (value: any) => rules.global.description.test(value.description),
				msg: {
					error: "La description de l'agence doit contenir au moins 10 caractères",
				},
			},
		},
	});

	const validationsManager = ref<any>({
		name: {
			value: newManagerData,
			validator: (value: any) => rules.global.userName.test(value.name),
			msg: {
				error: "Le nom du responsable doit contenir au moins 3 caractères",
			},
		},
		email: {
			value: newManagerData,
			validator: (value: any) => rules.global.email.test(value.email),
			msg: {
				error: "L'e-mail du responsable doit être valide",
			},
		},
		role: {
			value: newManagerData,
			validator: (value: any) => parseInt(value.role) > 0,
			msg: {
				error: "Le rôle du responsable est requis",
			},
		},
	});

	const columns = ref<any>([
		{
			name: "personal_info-name",
			label: "Nom",
			width: "25%",
		},
		{
			name: "roles-alias",
			label: "Rôle",
			width: "15%",
		},
		{
			name: "access",
			label: "Délai d'accès",
			width: "20%",
		},
	]);

	const modalName = ref("NewBeverageModal");
	const deleteManagerModalName = ref("deleteManagerModalName");
	const lockManagerModalName = ref("lockManagerModalName");
	const accessRoleAssignmentModalName = ref("accessRoleAssignmentModalName");
	const showModal = ref(false);
	const showDeleteManagerModal = ref(false);
	const showLockManagerModal = ref(false);
	const showaccessRoleAssignmentModal = ref(false);
	const selectedManager:any = ref(null);
	const optionsMoreActions = ref<any>([
		{
			icon: "/media/icons/remove-dropdown-icon.svg",
			name: "delete",
			label: "Supprimer",
			submenu: [],
		},
		{
			icon: "/media/icons/remove-dropdown-icon.svg",
			name: "lock",
			label: "Bloquer",
			submenu: [],
		},
	]);

	watch(
		() => currentTab.value,
		async () => {
			switch (currentTab.value) {
				case "global":
					// getAllPersonals()
					break;
				case "administration":
					// getAllPersonals()
					roleData.value = await getAllRoles({
						station: currentStation.value?.uuid,
						paginate: 'none',
					});
					break;

				default:
					break;
			}
			console.log("staffSelected.value: ", staffSelected.value);
		}
	);

	/**
	 * Functions
	 */
	const getStationInfos = async () => {
		isLoading.value = true;
		await api()
			.stations.get(stationIDSelected.value)
			.then((res: any) => {
				stationInfos.value = res.data;
				stationID.value = stationInfos.value.id;
			})
			.catch((err: any) => {
				console.log(err);
			});
		isLoading.value = false;
	};

	const getAllPersonals = async () => {
		isLoading.value = true;
		await api()
			.stations.users.personal.getAll(stationUUIDSelected.value, "&type=only-personal")
			.then((res: any) => {
				staffData.value = res.data.map((t: any) => {
					return { key: t.id, value: t.name };
				});
			})
			.catch((err: any) => {
				console.log(err);
			});
		isLoading.value = false;
	};

	const getAllManager = async () => {
		isLoading.value = true;
		await api()
			.stations.users.manager.getAll(stationIDSelected.value)
			.then((res: any) => {
				managerData.value = res.data;
			})
			.catch((err: any) => {
				console.log(err);
			});
		isLoading.value = false;
	};

	const handleUpdateStationInfos = async () => {
		isLoading.value = true;
		delete stationInfos.value.id;
		delete stationInfos.value.passengers_count;
		delete stationInfos.value.managers_count;
		delete stationInfos.value.users_count;
		// city peut être :
		//  - { id, name, … } quand l'API renvoie l'objet hydraté (load initial)
		//  - un id primitif quand on re-submit après un premier save (la ligne
		//    ci-dessous a remplacé l'objet par son id) → `id.id` crash
		//  - null / undefined si l'agence n'a pas de city set côté DB
		// Optional-chain + fallback gère les 3 cas sans crash.
		stationInfos.value.city = stationInfos.value.city?.id ?? stationInfos.value.city ?? null;

		await api()
			.stations.update(stationInfos.value, stationID.value)
			.then(async (res: any) => {
				await refreshUserInfos();
				await getAllStations(null, null, false);
				notify.success("Mise à jour effectuée avec succès");
			})
			.catch((err: any) => {
				console.log(err);
			});
		isLoading.value = false;
	};

	const updateStationInfos = async () => {
		if (validateAll(validations.value.station)) {
			handleUpdateStationInfos();
		} else {
			notify.warning("Veuillez correctement remplir les champs.");
		}
	};

	const handleCreateNewManager = async () => {
		isLoading.value = true;
		delete newManagerData.value.passwordRepeat;
		newManagerData.value.station = stationIDSelected.value;
		newManagerData.value.station = stationUUIDSelected.value;
		await api()
			.stations.users.manager.create(newManagerData.value)
			.then((res: any) => {
				notify.success("Utilisateur créé.");
				showModal.value = false;
				getAllManager();
			})
			.catch((err: any) => {
				console.log(err);
				notify.warning("Echec de création de l'utlisateur. Veuillez réessayer SVP.");
			});
		isLoading.value = false;
	};

	const assignNewResponsability = async () => {
		isLoading.value = true;
		if (validateAll(validations.value.staffSelected)) {
			await api()
				.stations.users.manager.assignRole(assignRoleData.value)
				.then((res: any) => {
					notify.success("Responsabilité assignée avec succès");
					getAllPersonals();
					getAllManager();
					showaccessRoleAssignmentModal.value = false;
				})
				.catch((err: any) => {
					console.log(err);
					notify.error("Echec d'assignation. Veuillez réessayer SVP.");
				});
		} else {
			notify.warning("Veuillez sélectionner un personnel qualifié.");
		}
		isLoading.value = false;
	};

	const createNewManager = async () => {
		if (validateAll(validationsManager.value)) {
			handleCreateNewManager();
		} else {
			notify.warning("Veuillez remplir tous les champs obligatoires.");
		}
	};

	const removeAccessManager = async () => {
		isLoading.value = true;
		const params = {
			user: selectedManager.value?.account?.id,
			station: currentStation.value?.key
		}
		await api()
		.stations.users.manager.removeAccess(generateQueryParams(params))
		.then((res: any) => {
			notify.success("Responsabilité retirée avec succès");
			getAllManager();
		})
		.catch((err: any) => {
			console.log(err);
			notify.error("Echec de suppression. Veuillez réessayer SVP.");
		});
		isLoading.value = false;
	};

	const lockAccessManager = async () => {
		isLoading.value = true;
		await api()
		.stations.users.manager.lockAccess(selectedManager.value?.account?.id, currentStation.value?.key)
		.then((res: any) => {
			notify.success("Utilisateur bloqué avec succès");
			getAllManager();
		})
		.catch((err: any) => {
			console.log(err);
			notify.error("Echec de blocage. Veuillez réessayer SVP.");
		});
		isLoading.value = false;
	};

	const modalState = (e: any) => {
		if (e === modalName.value) showModal.value = false;
	};

	const deleteManagerModalState = (e: any) => {
		if (e === deleteManagerModalName.value) showDeleteManagerModal.value = false;
	};

	const lockManagerModalState = (e: any) => {
		if (e === lockManagerModalName.value) showLockManagerModal.value = false;
	};

	const accessRoleAssignmentModalState = (e: any) => {
		if (e === accessRoleAssignmentModalName.value) showaccessRoleAssignmentModal.value = false;
		resetAssignRoleData()
	};

	const openAccessRoleAssigmentModal = (e: any) => {
		if (validateAll(validations.value.staffSelected)) {
			showaccessRoleAssignmentModal.value = true
		}
	};

	const execOptionsMoreActions = (data: any, clickedOptionName: string) => {
		switch (clickedOptionName) {
			case "delete":
				showDeleteManagerModal.value = true;
				break;
			case "lock":
				showLockManagerModal.value = true;
				break;
			}
			selectedManager.value = data;
			console.log('selectedManager.value: ', selectedManager.value);
	};

	const resetAssignRoleData = () => {
		assignRoleData.value.email = null
		assignRoleData.value.role = null
		assignRoleData.value.personal_id = null
	};

	/**
	 * Lifecycle
	 */
	onBeforeMount(async () => {
		await getStationInfos();
		await getAllManager();
		await getAllPersonals();

		// roleData.value = rolesUser();
	});

	onMounted(async () => {
		//
	});

return (_ctx: any,_cache: any) => {
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_TextAreaTag = _resolveComponent("TextAreaTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AppDatatable = _resolveComponent("AppDatatable")!
  const _component_TabBarTag = _resolveComponent("TabBarTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TabBarTag, {
      tabProps: tabProps.value,
      tabCentered: true,
      onCurrenttab: _cache[11] || (_cache[11] = (e) => currentTab.value = e)
    }, {
      global: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputTag, {
                placeholder: "Ex : Jahagal Voyage",
                value: stationInfos.value.station_name ?? '',
                onModel: _cache[0] || (_cache[0] = (e) => stationInfos.value.station_name = e),
                error: validations.value.station.station_name.message
              }, null, 8, ["value", "error"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputTag, {
                placeholder: "abc@exemple.com",
                value: stationInfos.value.station_email ?? '',
                onModel: _cache[1] || (_cache[1] = (e) => stationInfos.value.station_email = e),
                error: validations.value.station.station_email.message,
                type: "email"
              }, null, 8, ["value", "error"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_InputTag, {
                placeholder: "Mboppi Douala",
                value: stationInfos.value.station_address ?? '',
                error: validations.value.station.station_address.message,
                onModel: _cache[2] || (_cache[2] = (e) => stationInfos.value.station_address = e)
              }, null, 8, ["value", "error"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_InputTag, {
                placeholder: "Ex : +237 655 14 92 21",
                value: stationInfos.value.station_phone ?? '',
                error: validations.value.station.station_phone.message,
                onModel: _cache[3] || (_cache[3] = (e) => stationInfos.value.station_phone = e),
                type: "tel"
              }, null, 8, ["value", "error"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_InputTag, {
                placeholder: "Ex : BP 0000 Douala",
                value: stationInfos.value.postal_box ?? '',
                error: validations.value.station.postal_box.message,
                onModel: _cache[4] || (_cache[4] = (e) => stationInfos.value.postal_box = e),
                type: "text"
              }, null, 8, ["value", "error"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_TextAreaTag, {
                css: "mt-2",
                value: stationInfos.value.description ?? '',
                error: validations.value.station.description.message,
                onModel: _cache[5] || (_cache[5] = (e) => stationInfos.value.description = e)
              }, null, 8, ["value", "error"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_ButtonTag, {
              label: 'Enregistrer les modifications',
              onClick: updateStationInfos,
              loader: isLoading.value,
              textLoading: "Sauvegarde encours..."
            }, null, 8, ["loader"])
          ])
        ])
      ]),
      administration: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_SelectTag, {
                    css: '!mt-0',
                    placeholder: "Sélectionner un personnels qualifiés",
                    data: JSON.stringify(staffData.value),
                    error: validations.value.staffSelected.staff.message,
                    onModel: _cache[6] || (_cache[6] = (e) => assignRoleData.value.personal_id = e.key)
                  }, null, 8, ["data", "error"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_SelectTag, {
                    css: '!mt-0',
                    placeholder: "Sélectionner un niveau d'accès",
                    data: JSON.stringify(roleData.value),
                    error: validations.value.staffSelected.role.message,
                    onModel: _cache[7] || (_cache[7] = (e) => assignRoleData.value.role = e.key)
                  }, null, 8, ["data", "error"])
                ])
              ]),
              _createVNode(_component_ButtonTag, {
                label: 'Ajouter',
                class: "w-1/4",
                loader: isLoading.value,
                onClick: openAccessRoleAssigmentModal
              }, null, 8, ["loader"]),
              _createVNode(_component_Icon, {
                src: "/media/icons/new-user-icon.svg",
                css: "w-6 h-6",
                onClick: _cache[8] || (_cache[8] = () => (showModal.value = !showModal.value))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_AppDatatable, {
              heightTable: "calc(100vh - 32rem)",
              options: {
							columns: columns.value,
							data: managerData.value,
							isLoading: isLoading.value,
						},
              dynamicWidth: true,
              moreactions: {
								status: true,
								style: 'w-[15%]',
								stylerow: 'space-x-2',
								action_1: {
									status: false,
									icon: '/media/icons/download-datatable-icon.svg',
									style: 'w-6 h-6',
								},
								action_2: {
									status: false,
									icon: '/media/icons/print-datatable-icon.svg',
									style: 'w-6 h-6',
								},
								dot_action: {
									status: true,
									options: optionsMoreActions.value,
									onClick: (data, clickedOptionName,  clickedOptionSubName) => execOptionsMoreActions(data, clickedOptionName)
								},
							},
              onOnAction1: _cache[9] || (_cache[9] = (e) => {}),
              onOnAction2: _cache[10] || (_cache[10] = (e) => {})
            }, {
              "personal_info-name": _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_25, _toDisplayString(slotProps.data.personal_info?.name ?? "--"), 1)
              ]),
              "roles-alias": _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_26, _toDisplayString(slotProps.data.roles[0].alias ?? "--"), 1)
              ]),
              access: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            }, 8, ["options", "moreactions"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["tabProps"]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 0,
          title: "Nouvelle responsabilité",
          name: modalName.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          onClose: _cache[15] || (_cache[15] = (e) => modalState(e)),
          mounted: "async (e: any) => InitData()"
        }, {
          content: _withCtx(() => [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_InputTag, {
                  placeholder: "Ex : Jean BLO",
                  type: "text",
                  onModel: _cache[12] || (_cache[12] = (e) => newManagerData.value.name = e),
                  error: validationsManager.value.name.message
                }, null, 8, ["error"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_InputTag, {
                  placeholder: "Ex : abcde@email.com",
                  type: "email",
                  onModel: _cache[13] || (_cache[13] = (e) => newManagerData.value.email = e),
                  error: validationsManager.value.email.message
                }, null, 8, ["error"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_SelectTag, {
                  placeholder: "Sélectionner un niveau d'acces",
                  data: JSON.stringify(roleData.value),
                  error: validationsManager.value.role.message,
                  onModel: _cache[14] || (_cache[14] = (e) => newManagerData.value.role = e.key)
                }, null, 8, ["data", "error"])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_ButtonTag, {
                label: "Créer",
                loader: isLoading.value,
                "text-loading": 'Création en cours...',
                css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                onClick: createNewManager
              }, null, 8, ["loader"])
            ])
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true),
    (showDeleteManagerModal.value)
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 1,
          title: "Confirmation de Suppression",
          name: deleteManagerModalName.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: "!w-1/5",
          onClose: _cache[16] || (_cache[16] = (e) => deleteManagerModalState(e)),
          mounted: "async (e: any) => InitData()"
        }, {
          content: _withCtx(() => [
            _hoisted_37
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_ButtonTag, {
                label: "Confirmer",
                loader: isLoading.value,
                "text-loading": 'Suppression en cours...',
                css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                onClick: removeAccessManager
              }, null, 8, ["loader"])
            ])
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true),
    (showLockManagerModal.value)
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 2,
          title: "Limitation d'accès",
          name: lockManagerModalName.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: "!w-1/5",
          onClose: _cache[17] || (_cache[17] = (e) => lockManagerModalState(e)),
          mounted: "async (e: any) => InitData()"
        }, {
          content: _withCtx(() => [
            _hoisted_39
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_ButtonTag, {
                label: "Confirmer",
                loader: isLoading.value,
                "text-loading": 'Bloquage en cours...',
                css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                onClick: lockAccessManager
              }, null, 8, ["loader"])
            ])
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true),
    (showaccessRoleAssignmentModal.value)
      ? (_openBlock(), _createBlock(_component_ModalPage, {
          key: 3,
          title: "Assignation de rôle",
          name: accessRoleAssignmentModalName.value,
          styleContent: "w-full",
          styleFooter: "w-full",
          styleModal: "!w-1/5",
          onClose: _cache[19] || (_cache[19] = (e) => accessRoleAssignmentModalState(e)),
          mounted: "async (e: any) => InitData()"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_InputTag, {
                  placeholder: "Ex : abc@example.com",
                  type: "email",
                  onModel: _cache[18] || (_cache[18] = (e) => assignRoleData.value.email = e),
                  error: validations.value.assignRole.email.message
                }, null, 8, ["error"])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_ButtonTag, {
                label: "Confirmer",
                loader: isLoading.value,
                "text-loading": 'Assignation en cours...',
                css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
                onClick: assignNewResponsability
              }, null, 8, ["loader"])
            ])
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})